/* eslint-disable react/jsx-fragments */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'react-bootstrap';
import messages from './editClassMessages';
import * as helpers from './editClassHelpers';

import { getAbbreviation } from '../../app/utils/strings';

const StudentCardItem = (props) => {
  const initials = getAbbreviation(props.student.name);

  if (props.student.deleted) {
    return (
      <a className="card add-new card-list" style={{ backgroundColor: '#C1C1C1' }}>
        <span style={{ padding: 0, color: '#F8F8F8' }}>
          <div className="container">
            <div className="row align-items-center">
              <FormattedMessage {...messages.studentRemoved}>
                {(txt) => <div className="col-7 offset-2">{txt}</div>}
              </FormattedMessage>
              <div className="col-1 pt-2">
                <button
                  className="edit-card edit-card-variation"
                  style={{ color: '#fff' }}
                  onClick={() => props.onConfirmDelete(props.student)}
                >
                  <i className="pe-7s-check" />
                  Ok
                </button>
              </div>
              <div className="col-1 pt-2">
                <FormattedMessage {...messages.undo}>
                  {(txt) => (
                    <button
                      className="edit-card edit-card-variation"
                      style={{ color: '#fff' }}
                      onClick={() => props.onUndoDelete(props.student)}
                    >
                      <i className="ti-back-right" />
                      {txt}
                    </button>
                  )}
                </FormattedMessage>
              </div>
            </div>
          </div>
        </span>
      </a>
    );
  }
  return (
    <div className="card mt-3">
      <div className="card-body">
        <div className="row align-items-center">
          <div className="col-2">
            <div
              className="class-prefix class-prefix-variation"
              style={{ color: '#FFFFFF', backgroundColor: '#D4A1DD' }}
            >
              {initials}
            </div>
          </div>
          <div className="col-7">
            {props.errorDeleteStudent ===
              "Couldn't delete this student, due the already have an evaluations answered" &&
              props.student.id === props.idStudentSelected && (
                <Alert variant="danger">
                  <FormattedMessage {...messages.errorDeleteStudent} />
                </Alert>
              )}
            <span className="card-title">{props.student.name}</span>
          </div>
          {!props.readOnly && (
            <React.Fragment>
              <div className="col-1">
                <FormattedMessage {...messages.edit}>
                  {(txt) => (
                    <button
                      className="edit-card edit-card-variation"
                      onClick={() => props.onEdit(props.student)}
                    >
                      <i className="ti-pencil-alt" />
                      {txt}
                    </button>
                  )}
                </FormattedMessage>
              </div>
              <div className="col-1">
                <FormattedMessage {...messages.delete}>
                  {(txt) => (
                    <button
                      className="edit-card edit-card-variation"
                      onClick={() => props.onDelete(props.student)}
                    >
                      <i className="pe-7s-close-circle" />
                      {txt}
                    </button>
                  )}
                </FormattedMessage>
              </div>
            </React.Fragment>
          )}
          {props.readOnly && (
            <div className="col-2">
              <FormattedMessage {...messages.view}>
                {(txt) => (
                  <button
                    className="edit-card edit-card-variation"
                    onClick={() => props.onView(props.student)}
                  >
                    <i className="pe-7s-look" />
                    {txt}
                  </button>
                )}
              </FormattedMessage>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

StudentCardItem.propTypes = {};

StudentCardItem.defaultProps = {
  student: {},
  readOnly: true,
};

export default StudentCardItem;
